import { useEffect, useState } from "react";
import { Images, Sprout, Star } from "lucide-react";
import { api } from "../../lib/api";

const fmt = (iso) => new Date(iso).toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "long", year: "numeric" });

/** Album of end-of-session photos (newest first) with the Great Baobab growth (seeds) between sessions. */
export const AlbumGrid = ({ pid, cols = "grid-cols-2", empty = "Ta première photo apparaîtra ici à la fin de ta prochaine séance." }) => {
  const [photos, setPhotos] = useState(null);
  useEffect(() => { if (pid) api.get(`/patients/${pid}/photos`).then((r) => setPhotos(r.data)).catch(() => setPhotos([])); }, [pid]);
  if (!photos) return <div className="h-40 animate-pulse rounded-3xl bg-white/60" data-testid="album-loading" />;
  if (!photos.length) return <p className="rounded-3xl bg-white/80 p-5 text-sm text-slate-600" data-testid="album-empty"><Images className="mb-2 h-6 w-6 text-[#17A2A2]" />{empty}</p>;
  const first = photos[photos.length - 1].seeds;
  return (
    <div data-testid="album-grid">
      <div className="mb-3 rounded-2xl bg-[#0A2540] p-4 text-white" data-testid="album-growth">
        <p className="text-[10px] font-extrabold tracking-[0.25em] text-[#17A2A2]">CROISSANCE DU GRAND BAOBAB</p>
        <p className="mt-1 font-display text-xl font-bold">{first} → {photos[0].seeds} Graines de Vie</p>
        <p className="text-xs text-white/70">{photos.length} séance{photos.length > 1 ? "s" : ""} en photo · +{Math.max(0, photos[0].seeds - first)} graines depuis la première</p>
      </div>
      <div className={`grid gap-3 ${cols}`}>
        {photos.map((p, i) => (
          <figure key={p.id} className="overflow-hidden rounded-2xl bg-white shadow-sm" data-testid={`album-photo-${i}`}>
            <img decoding="async" src={`${process.env.REACT_APP_BACKEND_URL}${p.url}`} alt={`Séance du ${fmt(p.created_at)}`} loading="lazy" className="aspect-[4/5] w-full object-cover" />
            <figcaption className="p-2.5">
              <p className="truncate text-xs font-extrabold text-[#0A2540]">{p.title}</p>
              <p className="text-[11px] capitalize text-slate-500">{fmt(p.created_at)}</p>
              <p className="mt-1 flex items-center gap-2 text-[11px] font-bold text-[#0F7C7C]"><span className="flex items-center gap-0.5"><Star className="h-3 w-3 fill-[#E0B33A] text-[#E0B33A]" />{p.stars}</span><span className="flex items-center gap-0.5"><Sprout className="h-3 w-3" />{p.seeds}</span></p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
};
